import { shape, string, number, bool } from 'prop-types';
import React from 'react';
import PostByline from 'components/PostByline';
import FormattedDate from 'components/FormattedDate';

function PublishByline(props) {
  const { author, publishedAt, updatedAt, isAmp } = props;

  let bylineDate;
  let bylineLabel;

  // If we have a updatedAt date (via ACF field), always use that and
  // label it as "updated"
  if (updatedAt) {
    bylineDate = updatedAt;
    bylineLabel = 'updated';
  }

  // Otherwise display the original publish date and label it as such
  else {
    bylineDate = publishedAt;
    bylineLabel = 'published';
  }

  return (
    <div className="Post__byline">
      <PostByline author={author} isAmp={isAmp} />
      <div className="Post__published">
        <span className="Post__published-label">{bylineLabel}</span>{' '}
        <span className="Post__published-date">
          <FormattedDate timestamp={bylineDate} />
        </span>
      </div>
    </div>
  );
}

PublishByline.propTypes = {
  author: shape({
    name: string.isRequired,
    imageUrl: string,
    authorUrl: string
  }).isRequired,
  publishedAt: number.isRequired,
  updatedAt: number,
  isAmp: bool.isRequired
};

PublishByline.defaultProps = {
  updatedAt: undefined
};

export default PublishByline;
